export default {"en-US": __webpack_public_path__ + "i18n/en-US.71659a3d.i18next.json"};